import { Society } from 'types';

export const hasIntegrations = (society: Society): boolean =>
  society?.integrations?.factorial?.enabled ||
  society?.integrations?.personio?.enabled;
